<template>
      <div class="az-header">
        <div class="container-fluid">
          <div class="az-header-left">
            <!-- <a class="az-header-menu-icon" @click="changeSidebar()"><span></span></a> -->
            <el-button type="text" @click="changeSidebar()"><i class="fa fa-bars fa-lg"></i></el-button>
          </div><!-- az-header-left -->
          <div class="az-header-center">
            <!-- <input type="search" class="form-control" placeholder="Search for anything...">
            <button class="btn"><i class="fas fa-search"></i></button> -->
            <!-- <el-input 
            size='small'
            v-model="message" 
            prefix-icon="el-icon-search"
            placeholder="Search">
            </el-input> -->
          </div><!-- az-header-center -->
          <div class="az-header-right">
            <div class="dropdown az-header-notification show">
              <a type="button" class='new' @click="showAlert()" >
                <i class="typcn typcn-bell"></i>
              </a>
              <div class="dropdown-menu" v-show="isShowAlert">
                <div class="az-dropdown-header mg-b-20 d-sm-none">
                  <a href="" class="az-header-arrow"><i class="icon ion-md-arrow-back"></i></a>
                </div>
                <h6 class="az-notification-title">Notifications/Alerts</h6>
                <p class="az-notification-text" v-show='age_notifications.length === 0 && audit_notifications ===0'>You don't have notifications/alerts. </p>
                <div class="az-notification-list">
                  <div class="media new" v-for="(noti,index) in age_notifications" :key="index">
                    <div class="media-body">
                      <p>
                       {{isSample?'Mr Mike Sample '+(index+1):noti.name}} will reach age {{noti.age}} within {{noti.months>1?noti.months+' months':noti.months+' month'}}
                      </p>
                      <!-- <span>Mar 15 </span> -->
                    </div><!-- media-body -->
                  </div><!-- media -->
                </div><!-- az-notification-list -->
                <div class="dropdown-footer" v-if="age_notifications.length>0">
                  <a href="">View Details</a>
                </div>
                <div class="az-notification-list" v-if="audit_notifications>0">
                  <div class="media new" >
                    <div class="media-body">
                      <p>
                       {{audit_notifications>1?audit_notifications+' Funds':audit_notifications+" Funds"}} where Triple A/Preset are waiting for signature packs to be returned
                      </p>
                      <!-- <span>Mar 15 </span> -->
                    </div><!-- media-body -->
                  </div><!-- media -->
                </div><!-- az-notification-list -->
                <div class="dropdown-footer" v-if="audit_notifications>0">
                  <router-link class="nav-sub-link" :to='{path:"/adviserdashboard/fund_status_adviser",query:{page:"Fund Status"}}'>View Details</router-link>
                </div>
              </div><!-- dropdown-menu -->
            </div><!-- az-header-notification -->
            <div class="dropdown az-profile-menu show">
              <a type="button" class="az-img-user" @click="showAcc()" ><img :src="image" alt=""></a>
              <div class="dropdown-menu" v-show="isShowAcc">
                <div class="az-dropdown-header d-sm-none">
                  <a class="az-header-arrow"><i class="icon ion-md-arrow-back"></i></a>
                </div>
                <div class="az-header-profile">
                  <div class="az-img-user">
                    <img :src="image" alt="">
                  </div><!-- az-img-user -->
                  <h6 style="font-size:14px">{{isSample?'Sample User':firstname+' '+lastname}}</h6>
                  <span>{{isSample?'sample_user_email@gmail.com.au':email}}</span>
                </div><!-- az-header-profile -->
                <a href="https://www.tripleasuperdigital.com.au/contact" target="_blank" class="dropdown-item"><i class="typcn typcn-phone-outline"></i> Get help</a>
                <a type="button" :href='href' @click='logout()' class="dropdown-item"><i class="typcn typcn-power-outline"></i> Sign Out</a>
                <!-- <a href="" class="dropdown-item"><i class="typcn typcn-user-outline"></i> My Profile</a>
                <a href="" class="dropdown-item"><i class="typcn typcn-edit"></i> Edit Profile</a>
                <a href="" class="dropdown-item"><i class="typcn typcn-time"></i> Activity Logs</a>
                <a href="" class="dropdown-item"><i class="typcn typcn-cog-outline"></i> Account Settings</a> -->
                
              </div><!-- dropdown-menu -->
            </div>
          </div><!-- az-header-right -->
        </div><!-- container -->
      </div><!-- az-header -->
     
      
</template>
<script>
// import $ from 'jquery'
// import axios from 'axios'
// import '../../static/js/azia'
export default {
  name: 'Adviserheader',
  props: {
    
  },
  data(){
    return{
      isSample:false,
      isShowAlert: false,
      isShowAcc: false,
      firstname:'',
      lastname:'',
      email:'',
      image: '',
      age_notifications:[],
      audit_notifications:[],
      href:'https://idcs-ba07f5b4c1ee48fabd04112baf63ac43.identity.oraclecloud.com/oauth2/v1/userlogout?post_logout_redirect_uri=https%3A%2F%2Fdashboard.tripleasuperdigital.com.au%2F%23%2Flogin&id_token_hint='+ localStorage.getItem('id_token')

    }
  },
  created() {
    this.getHeader();
    this.getAgeNotifications();
    this.getAuditNotifications();
  },
  mounted() {
    window.addEventListener('click',this.close,true);
  },
  destroyed() {
    window.removeEventListener('click',this.close,true);
  },
  methods: { 
    logout: function () {
      this.$store.dispatch('logout')
      .then(() => {
        this.$router.push('/login')
      })
    },
    stopShaking(){
      if (this.classList.contains("shake")) {
          this.classList.remove("shake");
      }
    },
    showAcc: function(){
      this.isShowAcc = !this.isShowAcc;
    },
    showAlert: function(){
      this.isShowAlert = !this.isShowAlert;
    },
    
    close() {
      this.isShowAcc = false;
      this.isShowAlert = false;
    },
    changeSidebar:function(){
      this.$store.dispatch('sidebar')
    },
    getHeader: function(){
      const userdetail = JSON.parse(localStorage.getItem('userdetail'));
      this.isSample = userdetail['sample'];
      this.firstname = userdetail['firstname'];
      this.lastname = userdetail['lastname'];
      this.email = userdetail['email'];
      let avatar_name = this.isSample?'Sample+User':this.firstname+"+"+this.lastname
      this.image = "https://ui-avatars.com/api/?bold=true&background=3366ff&color=fff&name="+avatar_name;
    },
    getAgeNotifications: function(){
      const userdetail = JSON.parse(localStorage.getItem('userdetail'));
      let brand = userdetail['brand_list'][0][0];
      this.$api.adviserdashboard_api.age_notifications(brand).then(response =>{
          this.age_notifications = response.data['age_notifications']
      });
    },
    getAuditNotifications: function(){
      const userdetail = JSON.parse(localStorage.getItem('userdetail'));
      let brand = userdetail['brand_list'][0][0];
      this.$api.adviserdashboard_api.fund_status_adviser(brand).then(response =>{
          this.audit_notifications = response.data['no_audit_stage']
      });
    },
  },
    
}

</script>
<style scoped>
#chartdiv {
        width: 100%;
        height: 300px;
      }

      .shake {
        animation: shaker 0.5s;
        animation-iteration-count: infinite;
      }

.notice-swipe {
    height: 40px;
    line-height: 40px;
  }
</style>